"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TriggersChangedNotifyType = exports.TriggerPriceType = exports.TriggerType = exports.TriggerOrderStatus = void 0;
var TriggerOrderStatus;
(function (TriggerOrderStatus) {
    TriggerOrderStatus["OPEN"] = "open";
    TriggerOrderStatus["CANCELED"] = "canceled";
    TriggerOrderStatus["CLOSED"] = "closed";
})(TriggerOrderStatus = exports.TriggerOrderStatus || (exports.TriggerOrderStatus = {}));
var TriggerType;
(function (TriggerType) {
    /**大于等于*/
    TriggerType["GREATER_EQUAL"] = "GREATER_EQUAL";
    /**小于等于 */
    TriggerType["LESS_EQUAL"] = "LESS_EQUAL";
})(TriggerType = exports.TriggerType || (exports.TriggerType = {}));
var TriggerPriceType;
(function (TriggerPriceType) {
    /**最后成交价*/
    TriggerPriceType["LAST_PRICE"] = "LASTPRICE";
    /**标记价格 */
    TriggerPriceType["MARK_PRICE"] = "MARKPRICE";
})(TriggerPriceType = exports.TriggerPriceType || (exports.TriggerPriceType = {}));
/**TODO 新增通知类型 */
var TriggersChangedNotifyType;
(function (TriggersChangedNotifyType) {
})(TriggersChangedNotifyType = exports.TriggersChangedNotifyType || (exports.TriggersChangedNotifyType = {}));
